import { render } from "./PointHistorySp.vue?vue&type=template&id=453144da&scoped=true"
import script from "./PointHistorySp.vue?vue&type=script&lang=js"
export * from "./PointHistorySp.vue?vue&type=script&lang=js"

import "./PointHistorySp.vue?vue&type=style&index=0&id=453144da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453144da"]])

export default __exports__